module.exports = __webpack_public_path__ + "static/media/Heet_Shah_Resume_New.c01ee2ee.pdf";